import { Component, input, OnInit, output } from '@angular/core';
import { VisualElementComponent } from '@features/canvas/visual-element/visual-element.component';
import { convertLpColorToCSSColor } from '@shared/lp.utils';
import { LpPlaceableMedia } from '@typings/lp/generated';

@Component({
  selector: 'lp-placeable-media',
  imports: [VisualElementComponent],
  templateUrl: './lp-placeable-media.component.html',
  styleUrl: './lp-placeable-media.component.css',
})
export class LpPlaceableMediaComponent implements OnInit {
  media = input.required<LpPlaceableMedia>();

  started = output();
  finished = output();

  protected convertLpColorToCSSColor = convertLpColorToCSSColor;

  ngOnInit(): void {
    this.started.emit();
    if (this.media().dataType !== 'VideoPlaceableMedia') {
      this.finished.emit();
    }
  }
}
